module.exports = __webpack_public_path__ + "static/media/orange-sponge.4ce5bf73.jpg";